<script>
    import PromptAddHeader from '@/components/page-chat-gpt-edit/prompt-add/PromptAddHeader.vue';
    import PromptAddData from '@/components/page-chat-gpt-edit/prompt-add/PromptAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PROMPT_ADD}
        },
        components: {
            PromptAddHeader: PromptAddHeader,
            PromptAddData: PromptAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <PromptAddHeader />
        <hr class="hr_light_98">
        <PromptAddData />
    </div>
</template>